"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var Nav_1 = __importDefault(require("react-bootstrap/Nav"));
var SellerGroupModelListGroupSelection = /** @class */ (function (_super) {
    __extends(SellerGroupModelListGroupSelection, _super);
    function SellerGroupModelListGroupSelection(props) {
        var _this = _super.call(this, props) || this;
        _this.changeGroup = function (e) {
            console.log("selected group is: " + e.target.id);
            var nullIdIfEmptyValue = e.target.id ? e.target.id : null;
            _this.props.changeGroup(nullIdIfEmptyValue);
        };
        var groups = _this.props.groups;
        _this.state = {
            currentActiveGroup: groups ? groups[0].sellerProductGroupId : null,
        };
        return _this;
    }
    SellerGroupModelListGroupSelection.prototype.handleSelect = function (eventKey) {
        console.log("selected group is: " + eventKey);
        var nullIdIfEmptyValue = eventKey ? eventKey : null;
        this.setState({
            currentActiveGroup: eventKey,
        });
        this.props.changeGroup(nullIdIfEmptyValue);
    };
    SellerGroupModelListGroupSelection.prototype.render = function () {
        var _this = this;
        var groups = this.props.groups;
        var groupSelections = groups.map(function (group, index) { return (react_1.default.createElement(Nav_1.default.Item, { key: group.sellerProductGroupId },
            react_1.default.createElement(Nav_1.default.Link, { eventKey: group.sellerProductGroupId }, group.sellerProductGroupName))); });
        return (react_1.default.createElement(Nav_1.default, { variant: "pills", onSelect: function (k) { return _this.handleSelect(k); }, activeKey: this.state.currentActiveGroup }, groupSelections));
    };
    SellerGroupModelListGroupSelection.propTypes = {
        groups: prop_types_1.default.array.isRequired,
    };
    return SellerGroupModelListGroupSelection;
}(react_1.default.Component));
exports.default = SellerGroupModelListGroupSelection;
